import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {DataFormatService} from "../../../services/data-format.service";
import moment from 'moment';
import {formatCurrency} from "@angular/common";
import {Apollo} from "apollo-angular";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AddTaxCreditAppConfirmationComponent} from "./add-tax-credit-app-confirmation/add-tax-credit-app-confirmation.component";
import {create_app} from "./graphql/getAppInfo";

@Component({
    selector: 'deal-tax-credit-applications',
    templateUrl: './tax-credit-applications.component.html',
    styleUrls: ['./tax-credit-applications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaxCreditApplicationsComponent implements OnInit{
  @Input() applications: any;
  @Input() permissions: any;
  @Input() projectID: string;
  @Output() projectStatusChange: EventEmitter<any> = new EventEmitter();
  types: any;
  designations: any;
  hdas: any;
  newApps: any;
  apps: any;

  ngOnChanges(changes: SimpleChanges){
    if(changes.hasOwnProperty('applications')){
      this.newApps = this.applications ? [...this.applications] : [];
      this.apps = this.formatApplications(this.newApps);
    }
  }

  ngOnInit() {}

  constructor(private dataFormat: DataFormatService,
              private apollo: Apollo,
              private _snackBar: MatSnackBar,
              private dialog: MatDialog) {}

  formatApplications(apps: any): any{
    let format: any = [];
    for(let i = 0; i < apps.length; i++){
      let credit = apps[i]['taxCreditType']['level'] + " " + apps[i]['taxCreditType']['name'];
      if(apps[i]['taxCreditDesignation']){
        credit += " - " + apps[i]['taxCreditDesignation']['name'];
      }

      let awardedText = '';
      if(apps[i]['awarded'] !== null){
        awardedText = apps[i]['awarded'] ? "Awarded" : "Not Awarded";
      } else {
        awardedText = 'N/A'
      }

      let application = {
        id: apps[i]['id'],
        projectID: apps[i]['project_id'],
        fundingRoundID: apps[i].fundingRound ? apps[i].fundingRound.id : null,
        organizationID: apps[i].organization ? apps[i].organization.id : null,
        credit: credit,
        awarded: awardedText,
        awardedOld: apps[i]['awarded'] !== null ? apps[i]['awarded'] : 'n/a',
        awardedNew: apps[i]['awarded'] !== null ? apps[i]['awarded'] : 'n/a',
        amount: formatCurrency(apps[i]['amount_requested'], 'EN', '$', 'USD', '1.0-0'),
        amountOld: apps[i]['amount_requested'] ? apps[i]['amount_requested'].toString() : null,
        amountNew: apps[i]['amount_requested'] ? apps[i]['amount_requested'].toString() : null,
        requestDate: apps[i]['request_date'] ? moment
          .utc(apps[i]['request_date'])
          .format('MM/DD/YYYY') : '-',
        newDate: apps[i]['request_date'] ? new Date(moment.utc(apps[i]['request_date']).format("MM/DD/YYYY")).toISOString() : '-',
        isEditMode: false
      };

      let isFundingRound = application.fundingRoundID !== null;
      let key: number | null = null;

      if(format.length > 0){
        for(let j = 0; j < format.length; j++){
          if(isFundingRound && apps[i]['fundingRound']['id'] === format[j]['id']){
            key = j;
            break;
          } else if(!isFundingRound && apps[i]['organization']['id'] === format[j]['id']){
            key = j;
            break;
          }
        }
      }

      if(key === null){
        format.push({
          id: isFundingRound ? apps[i]['fundingRound']['id'] : apps[i]['organization']['id'],
          round: isFundingRound ? apps[i]['fundingRound']['year'] + " Round " + apps[i]['fundingRound']['number'] : null,
          roundName: isFundingRound ? apps[i]['fundingRound']['name'] : null,
          org: isFundingRound ? apps[i]['fundingRound']['organization']['name'] : apps[i]['organization']['name'],
          url: this.dataFormat.formatLink(isFundingRound ? apps[i]['fundingRound']['organization'] : apps[i]['organization']),
          awardDate: isFundingRound ? apps[i]['fundingRound']['award_date'] ? moment
          .utc(apps[i]['fundingRound']['award_date'])
          .format('MM/DD/YYYY') : 'N/A' : null,
          dueDate: isFundingRound ? apps[i]['fundingRound']['due_date'] ? moment
            .utc(apps[i]['fundingRound']['due_date'])
            .format('MM/DD/YYYY') : 'N/A' : null,
          table: [application]
        });
      } else {
        format[key].table.push(application);
      }
    }
    return format;
  }

  passFinancingTerm(data: any){
    for(let i = 0; i < this.apps.length; i++){
      if(this.apps[i].id === data.fundingRoundID){
        this.apps.splice(i, 1);
        break;
      }
    }

    for(let i = 0; i < this.newApps.length; i++){
      if(this.newApps[i].id === data.appID){
        this.newApps.splice(i, 1);
        break;
      }
    }
    this.apps = this.formatApplications(this.newApps);
  }

  passProjectStatus(data: any){
    this.projectStatusChange.emit(data);
  }

  addTaxCreditApplication(){
    const ref: MatDialogRef<AddTaxCreditAppConfirmationComponent> = this.dialog.open(
      AddTaxCreditAppConfirmationComponent,
      {
        width: '600px',
        height: '550px',
        data: {},
        backdropClass: 'confirmDialogComponent',
        hasBackdrop: true
      });
    ref.afterClosed().subscribe((data) => {
      if(data && data.clicked && data.clicked === 'Ok'){
        this.apollo
          .mutate({
            mutation: create_app,
            variables: {
              input: {
                project_id: this.projectID,
                tax_credit_type_id: data.taxCreditID,
                tax_credit_designation_id: data.taxCreditDesignationID,
                funding_round_id: data.fundingRoundID,
                organization_id: data.orgid,
                awarded: data.awarded,
                amount_requested: data.amount,
                request_date: data.request_date ? moment.utc(data.request_date).format('YYYY-MM-DD') : null
              }
            },
          })
          .subscribe(
            ({ data }) => {
              // @ts-ignore
              let newData: any = data.createApp;
              this.newApps.push(newData);
              this.apps = this.formatApplications(this.newApps);
              this.passProjectStatus({
                statuses: newData.project.projectStatuses,
                pipelines: newData.project.pipelineProjects
              });
            }
          );
      }
    });
  }

  openSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }
}
